import Constants from 'expo-constants';
import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY = 'legal.pendingSignupAcceptance';

function getWebStorage() {
  if (typeof localStorage === 'undefined') return null;
  if (typeof localStorage.getItem !== 'function') return null;
  if (typeof localStorage.setItem !== 'function') return null;
  if (typeof localStorage.removeItem !== 'function') return null;
  return localStorage;
}

export function getLegalClientContext(source: 'signup' | 'login_gate' | 'subscription' | 'manual') {
  let locale: string | undefined;

  try {
    locale = Intl.DateTimeFormat().resolvedOptions().locale || undefined;
  } catch {
    locale = undefined;
  }

  return {
    source,
    platform: Platform.OS,
    appVersion:
      Constants.expoConfig?.version
      ?? Constants.nativeAppVersion
      ?? 'unknown',
    ...(locale ? { locale } : {}),
  };
}

export async function markPendingLegalSignupAcceptance(): Promise<void> {
  const value = new Date().toISOString();

  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.setItem(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY, value);
    return;
  }

  await SecureStore.setItemAsync(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY, value);
}

export async function consumePendingLegalSignupAcceptance(): Promise<boolean> {
  let value: string | null = null;

  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    value = storage?.getItem(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY) ?? null;
    if (storage) storage.removeItem(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY);
    return value !== null;
  }

  value = await SecureStore.getItemAsync(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY);
  await SecureStore.deleteItemAsync(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY);
  return value !== null;
}

export async function clearPendingLegalSignupAcceptance(): Promise<void> {
  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.removeItem(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY);
    return;
  }

  await SecureStore.deleteItemAsync(PENDING_LEGAL_SIGNUP_ACCEPTANCE_KEY);
}
